<template>
  <div class="m-container">
    <slot></slot>
    <div class="close-container">
      <slot name="closeBtn">
        <el-button class="close-btn" :type="type" @click="handleBack">{{ text }}</el-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    //按钮文本
    text: { type: String, default: '关 闭' },
    //按钮类型
    type: { type: String, default: '' },
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/variables.less';
.m-container {
  padding-bottom: 50px;

  .close-container {
    position: fixed;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    padding: 5px 10px;
    width: 100%;
    background: @primary-color;
    z-index: 999;

    .close-btn {
      margin-right: 20px;
    }
  }
}
</style>
